/* Badasswear: uninterrupted collection browsing with Shopify pagination fallback. */
(() => {
  'use strict';

  const container = document.getElementById('ProductGridContainer');
  if (!container || container.dataset.badasswearInfiniteInit || !window.fetch || !('IntersectionObserver' in window)) return;
  container.dataset.badasswearInfiniteInit = '1';

  let grid = null;
  let pagination = null;
  let marker = null;
  let observer = null;
  let nextUrl = null;
  let loading = false;
  let revision = 0;

  function findNext(root) {
    const scope = root.querySelector('#ProductGridContainer');
    if (!scope) return null;
    const link = scope.querySelector('[data-badasswear-next][href]')
      || scope.querySelector('.pagination-wrapper a.pagination__item--prev[href]');
    if (!link) return null;
    try {
      const parsed = new URL(link.getAttribute('href'), window.location.href);
      return parsed.origin === window.location.origin ? parsed.toString() : null;
    } catch (_) {
      return null;
    }
  }

  function cleanup() {
    revision += 1;
    if (observer) observer.disconnect();
    if (marker) marker.remove();
    if (pagination) pagination.style.removeProperty('display');
    grid = null;
    pagination = null;
    marker = null;
    observer = null;
    nextUrl = null;
    loading = false;
  }

  async function getPage(url, sectionId) {
    const sectionUrl = new URL(url);
    sectionUrl.searchParams.set('section_id', sectionId);
    const requests = [sectionUrl.toString(), url];

    for (const request of requests) {
      try {
        const response = await fetch(request, { credentials: 'same-origin' });
        if (!response.ok) continue;
        const html = await response.text();
        const documentCopy = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = documentCopy.querySelector('#ProductGridContainer ul#product-grid');
        if (nextGrid && nextGrid.querySelector('li.grid__item')) {
          return { documentCopy, nextGrid };
        }
      } catch (_) {
        // Retry with the regular collection URL if the Section Rendering API failed.
      }
    }
    throw new Error('Could not load next collection page');
  }

  async function loadNext(requestRevision) {
    if (loading || !nextUrl || requestRevision !== revision || !grid) return;
    const currentGrid = grid;
    const next = nextUrl;
    loading = true;

    if (observer && marker) observer.unobserve(marker);

    try {
      const { documentCopy, nextGrid } = await getPage(next, currentGrid.dataset.id);
      if (requestRevision !== revision || grid !== currentGrid) return;

      const cards = [...nextGrid.querySelectorAll(':scope > li.grid__item')];
      if (!cards.length) throw new Error('Next page did not contain products');

      const fragment = document.createDocumentFragment();
      cards.forEach((card) => fragment.appendChild(card));
      currentGrid.appendChild(fragment);
      nextUrl = findNext(documentCopy);

      if (!nextUrl) {
        if (marker) marker.remove();
        marker = null;
        if (observer) observer.disconnect();
        observer = null;
      }
    } catch (error) {
      if (requestRevision === revision) {
        if (observer) observer.disconnect();
        if (marker) marker.remove();
        marker = null;
        observer = null;
        nextUrl = null;
        if (pagination) pagination.style.removeProperty('display');
        console.warn('Badasswear: automatic loading unavailable; page navigation restored.', error);
      }
    } finally {
      if (requestRevision === revision) {
        loading = false;
        if (nextUrl && observer && marker) observer.observe(marker);
      }
    }
  }

  function initialize() {
    const incomingGrid = container.querySelector('ul#product-grid');
    if (incomingGrid === grid) return;

    cleanup();
    if (!incomingGrid) return;

    grid = incomingGrid;
    nextUrl = findNext(document);
    if (!nextUrl) return;

    pagination = container.querySelector('.pagination-wrapper');
    const parent = pagination?.parentElement || grid.parentElement;
    marker = document.createElement('span');
    marker.className = 'badasswear-infinite-scroll-marker';
    marker.setAttribute('aria-hidden', 'true');
    marker.style.cssText = 'display:block;height:1px;width:100%';
    parent.appendChild(marker);

    const currentRevision = revision;
    observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNext(currentRevision);
    }, { rootMargin: '1200px 0px' });
    observer.observe(marker);

    if (pagination) pagination.style.display = 'none';
  }

  new MutationObserver(() => {
    if (container.querySelector('ul#product-grid') !== grid) initialize();
  }).observe(container, { childList: true });

  initialize();
})();